import { JobEntityStatusEnum, JobPurposeEnum } from '@/types/schema';

import { JobStateFragment } from '../../modules/bulk-import/graphql/fragments/generated/JobState';

export interface BulkExportProps {
  className?: string;
  purpose: JobPurposeEnum;
  job?: JobStateFragment;
  onCancelJob: (jobScheduleId: string) => void;
  customConfig?: Record<JobEntityStatusEnum, BulkExportItemConfigType>;
  hideCancel?: boolean;
}

export type BulkExportItemConfigType = {
  Icon: React.ReactNode;
  titleKey: string;
  descriptionKey: string;
  progress: number;
  action?: { id: ExportJobActions; textKey: string };
  rightNode?: React.ReactNode;
};

export enum ExportJobActions {
  Download = 'DOWNLOAD',
  TryAgain = 'TRY_AGAIN',
  Cancel = 'CANCEL',
}

export interface ExportJobType {
  id: string;
}
